import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #0a0a0a 0%, #1a0a2c 50%, #0a1a2c 100%);
  position: relative;
  padding: 3rem 2rem;
  text-align: center;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('/pattern-overlay.png');
    background-size: 150px;
    opacity: 0.03;
    z-index: 1;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(
      circle at bottom center,
      rgba(20, 241, 149, 0.05) 0%,
      rgba(0, 0, 0, 0) 70%
    );
    z-index: 0;
  }
`;

const Logo = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  background: ${props => props.theme.colors.gradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  z-index: 2;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2rem;
  position: relative;
  z-index: 2;
`;

const SocialLink = styled.a`
  color: ${props => props.theme.colors.text};
  font-size: 1.5rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: ${props => props.theme.colors.secondary};
  }
`;

const Copyright = styled.p`
  font-size: 0.9rem;
  color: #999;
  position: relative;
  z-index: 2;
`;

const MediaKitLink = styled.a`
  display: inline-block;
  color: ${props => props.theme.colors.secondary};
  margin-bottom: 1.5rem;
  font-size: 1rem;
  text-decoration: underline;
  transition: color 0.3s ease;
  position: relative;
  z-index: 2;
  
  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <Logo>Meme Retirement Home</Logo>
      <SocialLinks>
        <SocialLink href="https://t.me/memeretire" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-telegram-plane"></i>
        </SocialLink>
        <SocialLink href="https://x.com/meme_retirement" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-twitter"></i>
        </SocialLink>
      </SocialLinks>
      
      <MediaKitLink href="https://t.me/mrh_memes" target="_blank" rel="noopener noreferrer">
        Media Kit and Images
      </MediaKitLink>
      
      <Copyright>This is a meme project and crypto community coin with no intrinsic value or expectation of financial return.</Copyright>
    </FooterContainer>
  );
};

export default Footer; 